var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tooltip',{attrs:{"placement":"top","title":"Click to copy Asset ID"}},[_c('span',{staticStyle:{"cursor":"pointer","text-decoration":"underline"},on:{"click":_vm.copyAssetId}},[_vm._v(" Asset Id: "+_vm._s(_vm.assetId)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }